import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { env } from "@helpers/env";
import { getUserId } from "./UserHook";

export const useSentryUserContext = () => {
  const client = env.REACT_APP_NAME ?? "microtech";
  const userId = getUserId() as number;

  useEffect(() => {
    Sentry.setUser({
      id: userId,
      client: client,
    });

    Sentry.setTag("client", client);
  }, [userId, client]);

  return null;
};
